/**
 * UX mirror of functions/customers/accessControl.js.
 * Backend CUSTOMERS_LIST_ALLOWED_USER_IDS remains the source of truth.
 */
export const CUSTOMERS_LIST_ALLOWED_USER_IDS = [
  'kIAz8XBuTQdRoOFHfKFcgTNeE6O2', // Дмитро
  '26cky9lbSieNNuHaKJqGTvnNeY83', // Іванка
  '1uBaPmet8DQUlylFHTRnW35ypPQ2', // Галя
]

export const isCustomersListAllowedUser = (uid) =>
  Boolean(uid && CUSTOMERS_LIST_ALLOWED_USER_IDS.includes(uid))
